export enum EnvelopeSource {
    SIGNER = 1,
    EXTERNAL = 2,
}
